import React from "react";
import { useTranslation } from "react-i18next";
import { Clock, X } from "lucide-react";
import { Button } from "./ui/Primitives";

/**
 * Phase 29 — Banner shown at the top of a builder when an auto-saved draft
 * exists in localStorage from a previous session. User can restore or
 * discard the draft.
 *
 * @param {object} draft - {value, savedAt} or null
 * @param {function} onRestore - called when user clicks "Wiederherstellen"
 * @param {function} onDiscard - called when user clicks "Verwerfen"
 */
export default function DraftRestoreBanner({ draft, onRestore, onDiscard }) {
  const { t } = useTranslation();
  if (!draft) return null;
  const ageMin = Math.max(1, Math.round((Date.now() - draft.savedAt) / 60000));
  return (
    <div
      className="mx-6 mt-4 p-3 rounded-lg bg-warn/10 border border-warn/30 flex items-center justify-between gap-3"
      data-testid="draft-restore-banner"
    >
      <div className="flex items-center gap-2 text-sm">
        <Clock size={14} className="text-warn" />
        <span className="text-ink-secondary">
          {t("drafts.banner_text",
            "Ein automatisch gespeicherter Entwurf von vor ~{{n}} Min. wurde gefunden.",
            { n: ageMin })}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button size="sm" onClick={onRestore} data-testid="draft-restore-btn">
          {t("drafts.restore", "Wiederherstellen")}
        </Button>
        <Button size="sm" variant="ghost" onClick={onDiscard} data-testid="draft-discard-btn">
          <X size={12} /> {t("drafts.discard", "Verwerfen")}
        </Button>
      </div>
    </div>
  );
}
